import React, { useRef } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../style.scss";
import * as yup from "yup";
import { useFormik } from "formik";
import PreviewImage from "../../../Component/previewImage";
import { FileBox } from "../../../Component/form";
import { apiAdminConfig } from "../../../utils/api";
import useToast from "../../../provider/Toast/useToast";
import moment from "moment";

const EditAnnouncements = () => {
  const { id } = useParams();
  const toast = useToast();
  const fileRef = useRef(null);
  const navigate = useNavigate();

  const validationSchema = yup.object().shape({
    image: yup.mixed().required("Image is a required"),
    title: yup.string().required("Title is a required"),
    link: yup.string().required("Page Link is a required"),
  });

  const { handleSubmit, handleChange, setFieldValue, values, errors, touched, resetForm } =
    useFormik({
      initialValues: {
        image: null,
        title: "",
        link: "",
        date: "",
        organiser: ""
      },
      validationSchema,
      onSubmit: async () => {
        await apiAdminConfig.put(`admin/announcement/update/${id}`, values).then((response) => {
          if (response?.data.status) {
            navigate('/announcements')
            toast({
              message: response?.data?.message,
              bg: 'success'
            });
          } else {
            toast({
              message: response?.data?.message,
              bg: 'danger'
            });
          }
        }).catch((error) => {
          console.log("eventError", error)
          const { response } = error
          toast({
            message: response?.data?.message,
            bg: "danger",
          });
        })
      },
    });

  const bindData = async (id) => {
    await apiAdminConfig.get(`admin/announcementgetById/${id}`).then((response) => {
      if (response?.data?.status === true) {
        const { data } = response?.data;
        for (const [key] of Object.entries(values)) {
          if (key === "date") {
            setFieldValue("date", moment(data.date).format('YYYY-MM-DD'));
          } else {
            setFieldValue([key], data[key])
          }
        }
      }
    }).catch((error) => {
      console.log('EventError', error)
    })
  }
  React.useEffect(() => {
    if (id) {
      bindData(id);
    }
  }, [id]);

  return (
    <main id="announcements">
      <Container className="admin_padding">
        <div className="admin_add_form">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "14px 0",
              alignItems: "center",
            }}
            className="table-hader-container"
          >
            <div>
              <h3 className="table-hader-name">Edit Announcements</h3>
            </div>
            <Link to="/announcements" className="page_add_btn">
              Back
            </Link>
          </div>
          <Row>
            <Col>
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <FileBox
                        accept="image/*"
                        name="image"
                        label="ADD IMAGE"
                        onChange={(e) => {
                          setFieldValue("image", e)
                        }}
                        error={!!errors.image &&
                          touched.image && errors.image}
                        value={values?.image}
                        url="imageUpload/announcement"
                      />
                      {/* <Form.Control
                        hidden
                        type="file"
                        id="image_id"
                        ref={fileRef}
                        name="image"
                        accept="image/*"
                        // value={values.image}
                        onChange={(event) => {
                          setFieldValue(
                            "image",
                            event.target.files[0]
                          );
                        }}
                        isInvalid={
                          !!errors.image &&
                          touched.image
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.image}
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Col>
                      <div>
                        {values.image && (
                          <PreviewImage file={values.image} />
                        )}
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      TITLE<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      isInvalid={!!errors.title && touched.title}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.title}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={values.date}
                      min={new Date().toISOString().split('T')[0]}
                      onChange={(e) => {
                        setFieldValue("date", e.target.value)
                      }}
                      isInvalid={!!errors.date && touched.date}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.date}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      MAIN EVENT PAGE LINK IN APP
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="link"
                      value={values.link}
                      onChange={handleChange}
                      isInvalid={!!errors.link && touched.link}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.link}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="footer-btns"
                >
                  <Button type="submit" className="input_file_button">
                    Update
                  </Button>
                  <Link to="/announcements/create">
                    <Button onClick={() => resetForm()} className="input_file_button">Add More</Button>
                  </Link>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </main>
  );
};

export default EditAnnouncements;
